// extracted by mini-css-extract-plugin
export default {"Wrapper":"PopupBuy_Wrapper__dl0-7","content":"PopupBuy_content__n8Vxy"};